module.exports = __webpack_public_path__ + "static/media/grease-monkey.1e094aa8.svg";